module.exports = __webpack_public_path__ + "media/enterprise_powerlist/enterprise-powerlist-mobile-79aebbcb.png";